/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Problem_Pain_1Inputs */

const en_problem_pain_1 = /** @type {(inputs: Problem_Pain_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Too much, too long, no time`)
};

const de_problem_pain_1 = /** @type {(inputs: Problem_Pain_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zu viel, zu lang, zu wenig Zeit`)
};

const zh_tw_problem_pain_1 = /** @type {(inputs: Problem_Pain_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`太多太長沒時間看`)
};

const zh_cn_problem_pain_1 = /** @type {(inputs: Problem_Pain_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`太多太长没时间看`)
};

const es_problem_pain_1 = /** @type {(inputs: Problem_Pain_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Demasiados, demasiado largos, poco tiempo`)
};

const fr_problem_pain_1 = /** @type {(inputs: Problem_Pain_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trop nombreux, trop longs, pas le temps`)
};

const it_problem_pain_1 = /** @type {(inputs: Problem_Pain_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Troppi, troppo lunghi, zero tempo`)
};

const pt_br_problem_pain_1 = /** @type {(inputs: Problem_Pain_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conteúdo demais, tempo de menos`)
};

const ja_problem_pain_1 = /** @type {(inputs: Problem_Pain_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`多すぎて長すぎて時間がない`)
};

const ko_problem_pain_1 = /** @type {(inputs: Problem_Pain_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`너무 많고 길어서 볼 시간이 없고`)
};

const ru_problem_pain_1 = /** @type {(inputs: Problem_Pain_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Слишком много и слишком долго`)
};

const th_problem_pain_1 = /** @type {(inputs: Problem_Pain_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เยอะเกินไป ยาวเกินไป ไม่มีเวลาดู`)
};

const tr_problem_pain_1 = /** @type {(inputs: Problem_Pain_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Çok fazla, çok uzun, vakit yok`)
};

const ar_problem_pain_1 = /** @type {(inputs: Problem_Pain_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`كثيرة وطويلة ولا وقت كافٍ`)
};

/**
* | output |
* | --- |
* | "Too much, too long, no time" |
*
* @param {Problem_Pain_1Inputs} inputs
* @param {{ locale?: "en" | "de" | "zh_tw" | "zh_cn" | "es" | "fr" | "it" | "pt_br" | "ja" | "ko" | "ru" | "th" | "tr" | "ar" }} options
* @returns {LocalizedString}
*/
export const problem_pain_1 = /** @type {((inputs?: Problem_Pain_1Inputs, options?: { locale?: "en" | "de" | "zh_tw" | "zh_cn" | "es" | "fr" | "it" | "pt_br" | "ja" | "ko" | "ru" | "th" | "tr" | "ar" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Problem_Pain_1Inputs, { locale?: "en" | "de" | "zh_tw" | "zh_cn" | "es" | "fr" | "it" | "pt_br" | "ja" | "ko" | "ru" | "th" | "tr" | "ar" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_problem_pain_1(inputs)
	if (locale === "de") return de_problem_pain_1(inputs)
	if (locale === "zh_tw") return zh_tw_problem_pain_1(inputs)
	if (locale === "zh_cn") return zh_cn_problem_pain_1(inputs)
	if (locale === "es") return es_problem_pain_1(inputs)
	if (locale === "fr") return fr_problem_pain_1(inputs)
	if (locale === "it") return it_problem_pain_1(inputs)
	if (locale === "pt_br") return pt_br_problem_pain_1(inputs)
	if (locale === "ja") return ja_problem_pain_1(inputs)
	if (locale === "ko") return ko_problem_pain_1(inputs)
	if (locale === "ru") return ru_problem_pain_1(inputs)
	if (locale === "th") return th_problem_pain_1(inputs)
	if (locale === "tr") return tr_problem_pain_1(inputs)
	return ar_problem_pain_1(inputs)
});